#storage-protection-icap-content {
  width: 70%;

  #storage-protection-icap-info-text {
    color: var(--body-text-arrows-400);
  }

  .checkbox-with-input {
    display: flex;
    align-items: center;

    .checkbox-width {
      width: var(--form-field-label-width);
    }
  }

  #no-option-selected-notice {
    padding: calc(var(--spacer)) 0;
  }
}

gz-form-field {
  &#service-name-form-field,
  &#listen-non-secure-input-form-field,
  &#scan-archive-max-size-form-field,
  &#congestion-control-max-connections-form-field {
    --margin-bottom-wrapper: var(--spacer);
  }
  &#scan-archive-max-size-form-field,
  &#scan-archive-max-depth-form-field {
    --form-field-label-width: calc(250px - calc(var(--spacer) * 3.3));
    &::part(form-field-label) {
      min-width: auto;
    }
  }
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 4);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

gz-title + gz-form-field {
  margin-top: calc(var(--spacer) * 2);
}

.radio {
  display: flex;
  align-items: center;
}

gz-radio {
  margin-right: calc(2 * var(--spacer));
}
